import React, { createContext, useContext } from "react";
import { Button, Steps, Drawer, notification } from "antd";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { CloudUploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { observer } from "mobx-react-lite";
import { MonthlyProductionUpload } from "./MonthlyProductionUpload";
import { MonthlyParameterUpload } from "./MonthlyParameterUpload";
import { MonthlyReviewGrid } from "./MonthlyReviewGrid";
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
const { Step } = Steps;
export const UploadWizardConatiner = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);

  const steps = [
    {
      title: "STRINGs Production",
      content: <MonthlyProductionUpload />,
      description: "Upload Well/Strings Productions",
    },
    {
      title: "Subsurface Parameters",
      content: <MonthlyParameterUpload />,
      description: "Upload  Subsurface Parameters.",
    },
    {
      title: "Review data + Save",
      content: <MonthlyReviewGrid />,
      description: "QC productions,subsurface data and Save",
    },
  ];
  const next = () => {
    monthlyPerformanceStore.wizStep += 1;
  };

  const prev = () => {
    monthlyPerformanceStore.wizStep -= 1;
  };
  const saveMonthlyProduction = async () => {
    await monthlyPerformanceStore.saveMonthlyProduction();
  };
  return (
    <Drawer
      title={
        <>
          <CloudUploadOutlined styel={{ color: "red" }} />{" "}
          <span>{`NAOC Asset STRING Monthly Production for ${moment(
            monthlyPerformanceStore.uploadDate
          ).format("MMMM YYYY")}`}</span>
        </>
      }
      visible={monthlyPerformanceStore.showNaocMonthlyProductionDialog}
      onClose={() => {
        monthlyPerformanceStore.showNaocMonthlyProductionDialog = false;
      }}
      width={"80%"}
      destroyOnClose={true}
      drawerStyle={{ borderTop: "5px solid #F29C1F" }}
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <Steps current={monthlyPerformanceStore.wizStep} size="small">
              {steps.map((item) => (
                <Step
                  key={item.title}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
            <div
              className="steps-action"
              style={{
                display: "flex",
                justifyContent:
                  monthlyPerformanceStore.wizStep === 0
                    ? "flex-end"
                    : "space-between",
              }}
            >
              {monthlyPerformanceStore.wizStep > 0 && (
                <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
                  Previous
                </Button>
              )}
              {monthlyPerformanceStore.wizStep < steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={() => {
                    next();
                  }}
                  disabled={
                    monthlyPerformanceStore.uploadErrors.length > 0 ||
                    monthlyPerformanceStore.parauploadErrors.length > 0
                  }
                >
                  Next
                </Button>
              )}

              {monthlyPerformanceStore.wizStep === steps.length - 1 && (
                <Button
                  type="primary"
                  disabled={
                    monthlyPerformanceStore.monthlyProductions.size === 0 ||
                    monthlyPerformanceStore.monthlyRates.size === 0
                  }
                  onClick={async () => {
                    try {
                      await saveMonthlyProduction();
                      notification.success({
                        message: "SPARS Feedback",
                        description: `monthly productions data ${
                          monthlyPerformanceStore.reupload
                            ? "re-uploaded "
                            : "saved "
                        } successfully`,
                      });
                      let queryCriteria = {
                        startDate: moment(
                          monthlyPerformanceStore.uploadDate
                        ).format("YYYY-MM-01T00:00:00.000Z"),
                        endDate: moment(
                          monthlyPerformanceStore.uploadDate
                        ).format("YYYY-MM-01T00:00:00.000Z"),
                        fromInception: false,
                        specificDate: true,
                      };
                      monthlyPerformanceStore.queryCriteria = queryCriteria;
                      monthlyPerformanceStore.gridHeaderText = ` NAOC MONTHLY PRODUCTIONS for ${moment(
                        queryCriteria.startDate
                      ).format("MMM-YYYY")} `;

                      await monthlyPerformanceStore.loadProductions();
                      monthlyPerformanceStore.showNaocMonthlyProductionDialog = false;
                      monthlyPerformanceStore.resultFromQuery = false;
                      monthlyPerformanceStore.sheetName = "";
                      monthlyPerformanceStore.monthlyProductions.clear();
                      monthlyPerformanceStore.monthlyRates.clear();
                      monthlyPerformanceStore.wizStep = 0;
                    } catch (error) {
                      notification.error({
                        message: "SPARS Feedback",
                        description: error.response && error.response.text,
                      });
                    }
                  }}
                  loading={monthlyPerformanceStore.isSaving}
                >
                  Save
                </Button>
              )}
            </div>

            <div
              className="steps-content-2"
              style={{ paddingTop: "0px!important" }}
              id="jj"
            >
              {steps[monthlyPerformanceStore.wizStep].content}
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
});

